<template>
  <div>
    <!-- 卡片试图 -->
    <el-card class="box-card" v-loading="loading">
      <!-- 添加和搜索 -->
      <el-row :gutter="35">
        <el-form :model="searchQuery" ref="form" :inline="true" style="padding-left: 30px">
          <el-form-item :label="$t('clientmanage.table.merchantNo')" prop="merchantNo">
            <el-input size="mini" v-model="searchQuery.merchantNo" />
          </el-form-item>
          <el-form-item :label="$t('clientmanage.table.agentAccount')" prop="agentAcct">
            <el-input size="mini" v-model="searchQuery.agentAcct" />
          </el-form-item>
          <el-form-item :label="$t('clientmanage.table.payoutQueryUrl')" prop="payoutQueryUrl">
            <el-input size="mini" v-model="searchQuery.payoutQueryUrl" clearable />
          </el-form-item>
          <el-form-item :label="$t('clientmanage.table.payoutQueryStatus')">
            <el-select
              clearable
              v-model="searchQuery.payoutQueryStatus"
            >
              <el-option
                v-for="item in payoutQueryStatus"
                :label="item.label"
                :value="item.value"
                :key="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('clientmanage.table.merchantType')">
            <el-select
              v-model="searchQuery.merchantType"
              :placeholder="$t('clientmanage.addDialog.selectType')"
            >
              <el-option
                v-for="item in selectType"
                :label="item.label"
                :value="item.value"
                :key="item.label"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" @click="getClient()">{{ $t('btns.search') }}</el-button>
            <el-button size="mini" type="danger" @click="$refs.form.resetFields()">{{
              $t('btns.empty')
            }}</el-button>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 50px">
            <el-button
              size="mini"
              type="primary"
              v-if="permission.indexOf('merchant:refreshCache') > -1"
              @click="refreshCache()"
              >{{ $t('btns.refreshCache') }}
            </el-button>
            <el-button
              size="mini"
              type="primary"
              v-if="permission.indexOf('add:merchant') > -1"
              @click="handleOpen()"
              >{{ $t('clientmanage.table.addClient') }}
            </el-button>
            <el-button
              size="mini"
              type="primary"
              v-if="clientList.length && permission.indexOf('export:merchant') > -1"
              @click="handleExport()"
              >{{ $t('btns.export') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>

      <!-- 用户列表区域 -->
      <!-- el-bigdata-table 代替 el-table 解决数据量过大时输入框输入卡顿 -->
      <!-- <el-bigdata-table -->
       <el-table
        :data="clientList"
        stripe
        class="table"
        ref="table"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantName')"
          prop="merchantName"
        ></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantPhone')"
          prop="phone"
        ></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantNo')"
          prop="merchantNo"
        ></el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.agentAccount')"
          prop="agentAcct"
        ></el-table-column>
        <el-table-column :label="$t('clientmanage.table.merchantModel')" prop="merchantModel">
          <template slot-scope="scope">
            <div v-if="scope.row.merchantModel == 1">
              {{ $t('clientmanage.addDialog.optionModtext1') }}
            </div>
            <div v-if="scope.row.merchantModel == 2">
              {{ $t('clientmanage.addDialog.optionModtext2') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('clientmanage.table.merchantResources')"
          prop="merchantResources"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.merchantResources == 0">
              {{ $t('clientmanage.addDialog.optionRestext1') }}
            </div>
            <div v-if="scope.row.merchantResources == 1">
              {{ $t('clientmanage.addDialog.optionRestext2') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('clientmanage.table.merchantType')" prop="merchantType">
          <template slot-scope="scope">
            <div v-if="scope.row.merchantType == 0">
              {{ $t('clientmanage.addDialog.optionTypetext1') }}
            </div>
            <div v-if="scope.row.merchantType == 1">
              {{ $t('clientmanage.addDialog.optionTypetext2') }}
            </div>
            <div v-if="scope.row.merchantType == 2">
              {{ $t('clientmanage.addDialog.optionTypetext3') }}
            </div>
          </template>
        </el-table-column>
         <el-table-column :label="$t('clientmanage.addDialog.payoutType')" prop="type">
          <template slot-scope="scope">
            <div v-if="scope.row.type == 0">
              {{ $t('clientmanage.addDialog.normalPayout') }}
            </div>
            <div v-if="scope.row.type == 1">
              {{ $t('clientmanage.addDialog.specialPayout') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('clientmanage.table.merchantStatus')">
          <template slot-scope="scope">
            <el-switch
              class="demo"
              v-model="scope.row.merchantStatus"
              @change="merchantStatusChange(scope.row, 'merchantStatus')"
              :active-value="0"
              :inactive-value="1"
              inactive-color="#F56C6C"
              active-color="#00A854"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column :label="$t('clientmanage.table.operaTion')" width="200">
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-tooltip
              :key="`${scope.row.id}-1`"
              effect="dark"
              :content="$t('clientmanage.table.changemessage')"
              placement="top"
              enterable
              v-if="permission.indexOf('update:merchant') > -1"
            >
              <el-popconfirm
                :ref="`popover-${scope.row.id}-1`"
                :title="$t('orders.tip.danger')"
                @confirm="handleOpen(scope.row)"
              >
                <el-button
                  slot="reference"
                  type="primary"
                  icon="el-icon-edit"
                  size="medium"
                  circle
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
            <!-- 查看商户详情 -->
            <el-tooltip
              :key="`${scope.row.id}-2`"
              v-if="permission.indexOf('merchantdetails:manager') > -1"
              effect="dark"
              :content="$t('clientmanage.table.checkmessage')"
              placement="top"
              enterable
            >
              <el-button
                type="primary"
                icon="el-icon-zoom-in"
                @click="checkClient(scope.row.merchantNo)"
                size="medium"
                circle
              ></el-button>
            </el-tooltip>
            <!-- 重置密码 -->
            <el-tooltip
              :key="`${scope.row.id}-3`"
              effect="dark"
              :content="$t('accountmanager.resetPass')"
              placement="top"
              :enterable="false"
              v-if="permission.indexOf('merchant:restPayPassword') > -1"
            >
              <el-popconfirm
                :ref="`popover-${scope.row.id}-3`"
                :title="$t('orders.tip.danger')"
                @confirm="resetpassword(scope.row)"
              >
                <el-button
                  slot="reference"
                  type="warning"
                  icon="el-icon-setting"
                  size="medium"
                  circle
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
            <!-- 查看密钥 -->
            <el-tooltip
              :key="`${scope.row.id}-4`"
              effect="dark"
              :content="$t('accountmanager.checkKey')"
              placement="top"
              :enterable="false"
            >
              <el-popconfirm
                :ref="`popover-${scope.row.id}-4`"
                :title="$t('orders.tip.danger')"
                @confirm="showKeysInfo(scope.row)"
              >
                <el-button
                  slot="reference"
                  type="success"
                  icon="el-icon-document-checked"
                  size="medium"
                  circle
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <v-pagination
        v-model="pagination"
        :size="pagination.size"
        :sizes="[10,20,50,100]"
        :total="tableData.rows"
        @update="getClient"
      />
      <!-- /* ---------------------------------- 新增商户 ---------------------------------- */ -->
      <el-dialog
        :title="$t(`merchantIp.title.${isAdd ? 'add' : 'editor'}`)"
        :visible.sync="addClientDialogVisible"
        :close-on-click-modal="false"
        width="50%"
      >
        <!-- /* ---------------------------------- 代理表单 ---------------------------------- */ -->
        <el-form :model="addClient" v-bind="formProps.form">
          <el-form-item prop="merchantType" :label="$t('clientmanage.table.merchantType')">
            <template>
              <el-select
                v-model="addClient.merchantType"
                :placeholder="$t('clientmanage.addDialog.selectType')"
              >
                <el-option
                  v-for="item in selectType"
                  :label="item.label"
                  :value="item.value"
                  :key="item.label"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>

          <template v-if="addClient.merchantType">
            <el-form-item
              prop="agentAcct"
              :label="$t('clientmanage.table.agentAccount')"
              :rules="{ required: addClient.merchantType != 2 }"
            >
              <!-- /* -------------------------------------------------------------------------- */
              /*                              1. 管理员新建代理。可以输入代理                             */
              /*                              2. 管理员新建商户，拉取所有代理使用select供选择                            */
              /*                              3. 代理新建商户，代理就是他自己。禁用表单                          */
              /* -------------------------------------------------------------------------- */ -->
              <el-select
                style="width: 300px"
                v-model="addClient.agentAcct"
                :disabled="!isAdd"
                v-if="userType === 0 && addClient.merchantType === 2"
              >
                <el-option
                  v-for="item in agents"
                  :key="item.id"
                  :label="`${item.merchantName}-${item.merchantNo}`"
                  :value="item.merchantNo"
                >
                </el-option>
              </el-select>
              <el-input v-model="addClient.agentAcct" :disabled="!isAdd || userType === 1" v-else />
            </el-form-item>
            <!-- /* ---------------------------- 只有建商户时方显示商户资源商户类型 --------------------------- */ -->
            <template v-if="addClient.merchantType === 2">
              <el-form-item prop="merchantModel" :label="$t('clientmanage.table.merchantModel')">
                <template>
                  <el-select
                    v-model="addClient.merchantModel"
                    :placeholder="$t('clientmanage.addDialog.selectModel')"
                  >
                    <!-- <el-option
                      :value="1"
                      :label="`1：${$t('clientmanage.addDialog.optionModtext1')}`"></el-option>
                    <el-option
                      :value="2"
                      :label="`2：${$t('clientmanage.addDialog.optionModtext2')}`"></el-option> -->

                    <el-option
                      :value="2"
                      :label="`${$t('clientmanage.addDialog.optionModtext2')}`"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>

              <el-form-item
                prop="merchantResources"
                :label="$t('clientmanage.table.merchantResources')"
                v-if="!isAdd"
              >
                <template>
                  <el-select
                    v-model="addClient.merchantResources"
                    :placeholder="$t('clientmanage.addDialog.selectResour')"
                  >
                    <el-option
                      :value="0"
                      :label="`0：${$t('clientmanage.addDialog.optionRestext1')}`"
                    ></el-option>
                    <el-option
                      :value="1"
                      :label="`1：${$t('clientmanage.addDialog.optionRestext2')}`"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </template>

            <el-form-item
              prop="merchantWithdrawalType"
              :label="$t('clientmanage.updataDia.merchantWithdrawalType')"
              v-if="!isAdd"
            >
              <template>
                <el-select
                  v-model="addClient.merchantWithdrawalType"
                  :placeholder="$t('clientmanage.updataDia.updatamerchantWithdrawalType')"
                >
                  <el-option
                    :value="0"
                    :label="`0：${$t('clientmanage.addDialog.optionWithdratext1')}`"
                  ></el-option>
                  <el-option
                    :value="1"
                    :label="`1：${$t('clientmanage.addDialog.optionWithdratext2')}`"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
            <!-- 代付查询状态 -->
            <el-form-item :label="$t('clientmanage.table.payoutQueryStatus')" prop="payoutQueryStatus">
                <el-select
                  clearable
                  v-model="addClient.payoutQueryStatus"
                >
                  <el-option
                    v-for="item in payoutQueryStatus"
                    :label="item.label"
                    :value="item.value"
                    :key="item.label"
                  />
                </el-select>
            </el-form-item>
             <!-- 代付查询地址 -->
             <el-form-item :label="$t('clientmanage.table.payoutQueryUrl')" prop="payoutQueryUrl">
              <el-input size="mini" v-model="addClient.payoutQueryUrl" clearable />
            </el-form-item>
            <el-form-item prop="type" :label="$t('clientmanage.addDialog.payoutType')">
              <el-select style="width: 300px" v-model="addClient.type">
                <el-option
                  :value="0"
                  :label="$t('clientmanage.addDialog.normalPayout')"
                ></el-option>
                <el-option
                  :value="1"
                  :label="$t('clientmanage.addDialog.specialPayout')"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 商户取款最低安全金额 -->
            <el-form-item
              :label="$t('clientmanage.Merchant_Withdrawal_Minimum_Security_Limit')"
              prop="withdrawMinSafetyAmount"
            >
              <el-input
                type="number"
                v-model.trim="addClient.withdrawMinSafetyAmount"
                :placeholder="
                  $t('clientmanage.Please_enter_the_minimum_security_limit_for_merchant_payment')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 取款警告id -->
            <el-form-item :label="$t('clientmanage.Withdrawal_warning_group_ID')" prop="withdrawWarningGroupId">
              <el-input
                v-model="addClient.withdrawWarningGroupId"
                :placeholder="$t('clientmanage.Please_enter_the_withdrawal_warning_group_ID')"
              >
              </el-input>
            </el-form-item>

            <!-- 商户代付最低安全金额 -->
            <el-form-item
              :label="$t('clientmanage.Minimum_safety_limit_for_merchant_payment')"
              prop="payoutMinSafetyAmount"
            >
              <el-input
                type="number"
                v-model.trim="addClient.payoutMinSafetyAmount"
                :placeholder="
                  $t('clientmanage.Please_enter_the_minimum_security_limit_for_merchant_payment')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 代付警告id -->
            <el-form-item
              :label="$t('clientmanage.Payment_warning_group_id')"
              prop="payoutWarningGroupId"
            >
              <el-input
                v-model.trim="addClient.payoutWarningGroupId"
                :placeholder="$t('clientmanage.Please_enter_the_payment_warning_group_id')"
              >
              </el-input>
            </el-form-item>
            <!--            商户前缀-->
            <el-form-item prop="orderPrefix" :label="$t('clientmanage.addDialog.orderPrefix')">
              <el-input
                v-model="addClient.orderPrefix"
                oninput="value=value.replace(/[^\dA-Za-z]/g,'')"
                :placeholder="$t('clientmanage.addDialog.placeholdertext')"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item :label="$t('clientmanage.table.merchantStatus')">
              <template>
                <el-switch
                  class="demo"
                  v-model="addClient.merchantStatus"
                  :active-value="0"
                  :inactive-value="1"
                  inactive-color="#F56C6C"
                  active-color="#00A854"
                >
                </el-switch>
              </template>
            </el-form-item>

            <el-form-item :label="$t('clientmanage.table.merchantName')" prop="merchantName">
              <el-input
                v-model="addClient.merchantName"
                :placeholder="$t('clientmanage.addDialog.placeholderName')"
              >
              </el-input>
            </el-form-item>

            <el-form-item :label="$t('clientmanage.addDialog.phone')" prop="phone">
              <el-input
                v-model.trim="addClient.phone"
                :placeholder="$t('accountmanager.addFormPhone')"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('accountmanager.email')" prop="email">
              <el-input
                v-model="addClient.email"
                :placeholder="$t('accountmanager.addFormEmail')"
              ></el-input>
            </el-form-item>

            <!-- /* ----------------------------- 仅在添加商户时才展示密码表单 ----------------------------- */ -->
            <template v-if="isAdd">
              <el-form-item :label="$t('clientmanage.addDialog.userPass')" prop="userPass">
                <el-input
                  show-password
                  v-model="addClient.userPass"
                  :placeholder="$t('accountmanager.addFormPass')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('clientmanage.addDialog.payPass')" prop="payPass">
                <el-input
                  show-password
                  v-model="addClient.payPass"
                  maxlength="20"
                  :placeholder="$t('accountmanager.addFormPass')"
                ></el-input>
              </el-form-item>
            </template>

            <el-form-item :label="$t('clientmanage.label.card')" prop="card">
              <el-input v-model.trim="addClient.card" :placeholder="$t('clientmanage.placeholder.card')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('clientmanage.label.merchantWithdrawalFee')"
              prop="merchantWithdrawalFee"
            >
              <el-input
                v-model.trim="addClient.merchantWithdrawalFee"
                :placeholder="$t('clientmanage.placeholder.merchantWithdrawalFee')"
              >
              </el-input>
            </el-form-item>

            <el-form-item :label="$t('clientmanage.label.momo')" prop="momo">
              <el-input v-model.trim="addClient.momo" :placeholder="$t('clientmanage.placeholder.momo')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('clientmanage.label.momoIpay')" prop="momoIpay">
              <el-input
                v-model="addClient.momoIpay"
                :placeholder="$t('clientmanage.placeholder.momoIpay')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item> -->
            <el-form-item
              :label="$t('clientmanage.label.onlineBankingDirectConnect')"
              prop="onlineBankingDirectConnect"
            >
              <el-input
                v-model.trim="addClient.onlineBankingDirectConnect"
                :placeholder="$t('clientmanage.placeholder.onlineBankingDirectConnect')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('clientmanage.label.onlineBankingQr')" prop="onlineBankingQr">
              <el-input
                v-model.trim="addClient.onlineBankingQr"
                :placeholder="$t('clientmanage.placeholder.onlineBankingQr')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('clientmanage.label.vipQr')" prop="qrPro">
              <el-input
                v-model.trim="addClient.qrPro"
                :placeholder="$t('clientmanage.placeholder.vipQr')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('clientmanage.label.payOnBehalfOf')" prop="payOnBehalfOf">
              <el-input
                v-model="addClient.payOnBehalfOf"
                :placeholder="$t('clientmanage.placeholder.payOnBehalfOf')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <!-- 代付固定手续费 -->
            <el-form-item :label="$t('clientmanage.label.payoutFixedFee')" prop="payoutFixedFee">
              <el-input
                v-model.trim="addClient.payoutFixedFee"
                :placeholder="$t('clientmanage.placeholder.payoutFixedFee')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('clientmanage.label.viettelpay')" prop="viettelpay">
              <el-input
                v-model.trim="addClient.viettelpay"
                :placeholder="$t('clientmanage.placeholder.viettelpay')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('clientmanage.label.zalo')" prop="zalo">
              <el-input v-model.trim="addClient.zalo" :placeholder="$t('clientmanage.placeholder.zalo')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('clientmanage.label.usdt')" prop="usdt">
              <el-input v-model.trim="addClient.usdt" :placeholder="$t('clientmanage.placeholder.usdt')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
              <!-- momoBank手续费 -->
            <el-form-item :label="$t('clientmanage.label.momoBank')" prop="momoBank">
              <el-input  v-model.trim="addClient.momoBank" :placeholder="$t('clientmanage.placeholder.momoBank')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
              <!-- zaloBank手续费 -->
              <el-form-item :label="$t('clientmanage.label.zaloBank')" prop="zaloBank">
              <el-input  v-model.trim="addClient.zaloBank" :placeholder="$t('clientmanage.placeholder.zaloBank')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
             <!-- vtpBank手续费 -->
             <el-form-item :label="$t('clientmanage.label.vtpBank')" prop="vtpayBank">
              <el-input  v-model.trim="addClient.vtpayBank" :placeholder="$t('clientmanage.placeholder.vtpBank')">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('welcome.label.channel')" v-if="!isAdd">
              <template>
                <div v-for="key in Object.keys(checkboxes)" :key="key" style="margin-left: 70px">
                  <p style="font-weight: bold">{{ key }}:</p>
                  <el-checkbox-group ref="checkboxesGroup" v-model="checkedChannels">
                    <el-checkbox
                      v-for="item in checkboxes[key]"
                      :checked="item.status == 1"
                      :key="item.id"
                      :label="item.id"
                      >{{ item.channelCode }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </template>
            </el-form-item>
          </template>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addClientDialogVisible = false">{{
            $t('accountmanager.cancel')
          }}</el-button>
          <el-button type="primary" @click="handleConfirm"
            >{{ $t('accountmanager.confirm') }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="showKeysInfoFlag" :close-on-click-modal="false" width="30%">
        <el-form :model="merchantKeys" label-width="100px">
          <el-form-item :label="$t('clientmanage.addDialog.payPass')">
            <label>{{ merchantKeys.merchantKey }}</label>
          </el-form-item>
          <el-form-item :label="$t('clientmanage.addDialog.googleCode')">
            <label>{{ merchantKeys.secret }}</label>
          </el-form-item>
          <el-form-item :label="$t('clientmanage.addDialog.googleQrCode')">
            <img :src="merchantKeys.secretQr" alt width="150" height="150" />
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>

    <el-dialog width="90%" :visible.sync="isDetail">
      <merchantdetails :isBack="false" :key="newKey"></merchantdetails>
    </el-dialog>
    <QrCodeModal ref="qrCodeModal"/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import merchantApi from '@/api/merchant';
import ordersApi from '@/api/orders';
import { validEmail, checkPass, validPhone, isNumber, betweenLenNumber } from '@/utils/validate';
import base from '@/mixin/base.js';
import merchantdetails from './merchantdetails.vue';
import QrCodeModal from '@/components/qrCodeModa';

export default {
  mixins: [base],
  name: 'Clientmanage',
  components: {
    merchantdetails,QrCodeModal
  },
  data() {
    return {
      newKey:Date.parse(new Date()),
      showKeysInfoFlag: false,
      merchantKeys: {
        merchantKey: '',
        secret: '',
        secretQr: ''
      },
      tableData: {},
      agents: [],
      /* ---------------------------------- 搜索表单 ---------------------------------- */
      searchQuery: {
        //获取商户的参数
        merchantNo: '',
        agentAcct: '',
        merchantType: null,
        payoutQueryUrl:'',
        payoutQueryStatus:null,
      },
      pagination: {
        current: 1,
        size: 100,
        no: 1
      },
      checkClientDialogVisible: false, //控制商户详细信息的对话框

      isAdd: true,
      addClientDialogVisible: false, //控制新增商户的对话框
      loading: false, //整页loading
      rolestorage: [], //获取角色列表，给新增用户添加角色
      wallettypes: [], //钱包类型

      addClient: {
        //新增商户的参数对象
        id: '',
        merchantWallet: 'all',
        merchantStatus: 0,
        type: '',

        merchantModel: null,
        merchantResources: 0,
        merchantType: null,
        agentAcct: '',
        merchantName: '',
        userPass: '',
        payPass: '',
        phone: '',
        email: '',
        withdrawMinSafetyAmount:0,//商户取款最低安全限额
        withdrawWarningGroupId:'',//取款警告群组id
        payoutWarningGroupId: '', //代付警告群组id
        payoutMinSafetyAmount: 0, //商户代付最低安全限额
        // 手续费
        card: '',
        merchantWithdrawalFee: '',
        merchantWithdrawalType: 1,
        momo: '',
        momoIpay: '',
        onlineBankingDirectConnect: '',
        onlineBankingQr: '',
        payOnBehalfOf: '',
        viettelpay: '',
        zalo: '',
        usdt: '',
        qrPro: '',
        orderPrefix: '',
        payoutQueryUrl:'',
        payoutQueryStatus:null,
        payoutFixedFee:'',
      },
      checkboxes: {},
      checkedChannels: [],
      isDetail: false,
      //开始索引
      // startIndex: 0,
      //选中的数据
      // selectedRows: [],
      // 空元素，用于撑开table的高度
      // vEle: undefined
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info || {}
    }),
    ...mapGetters(['permission']),
    userType() {
      return this.info.userType;
    },
    clientList() {
      return this.tableData.list || [];
    },

    roleId() {
      if (this.addClient.merchantType === 1) {
        return this.rolestorage.find((item) => item.roleCode === 'agent').id;
      } else {
        if (this.addClient.merchantResources === 0) {
          return this.rolestorage.find((item) => item.roleCode === 'shanghuzj').id;
        } else if (this.addClient.merchantResources === 1) {
          return this.rolestorage.find((item) => item.roleCode === 'shanghu').id;
        } else {
          return '';
        }
      }
    },
    selectType() {
      /**
       * usertype === 0 管理员用户，可以添加商户类型有商户与代理
       */
      return [
        {
          label: this.$t('clientmanage.addDialog.optionTypetext3'),
          value: 2
        }
      ].concat(
        this.userType === 0
          ? [
              {
                label: this.$t('clientmanage.addDialog.optionTypetext2'),
                value: 1
              }
            ]
          : []
      );
    },
    payoutQueryStatus () {
      return [
        {
          label: this.$t('status.close'),
          value: 1
        },
        {
          label: this.$t('status.open'),
          value: 0
        },

      ]
    }
    //这个是截取表格中的部分数据，放到了 table中来显示
    // sliceTable() {
    //   return this.clientList.slice(this.startIndex, this.startIndex + 9);
    // }
  },
  watch: {
    'addClient.merchantType'() {
      if (this.isAdd) {
        this.addClient.agentAcct = '';
      }
      /* -------------------------------------------------------------------------- */
      /*                               管理员新建代理时可以输入代理                               */
      // if (this.userType === 0) {
      //   if (this.addClient.merchantType === 1) {
      //     this.addClient.agentAcct = this.info.userName;
      //   }
      // }
      /*                               管理员新建代理时可以输入代理                               */
      /* -------------------------------------------------------------------------- */
      if (this.userType === 1) {
        this.addClient.agentAcct = this.info.userName;
      }
    }
  },
  created() {
    this.init();
    //创建一个空元素，这个空元素用来撑开 table 的高度，模拟所有数据的高度
    // this.vEle = document.createElement('div');
    // this.loadDate()
  },
  mounted() {
    this.roleList();
    this.getClient();
    this.wallettype();
    this.getAgents();
    // 绑定滚动事件
    // this.$refs.table.$el
    //   .querySelector('.el-table_body-wrapper')
    //   .addEventListener('scroll', this.tableScroll, {
    //     passive: true
    //   });
  },
  methods: {
    init() {
      this.handleEmpty();
      /* ----------------------------- element -props ----------------------------- */
      this.formProps = {
        form: {
          ref: 'form',
          inline: false,
          size: 'small',
          rules: {
            payoutQueryStatus: {
              required: true,
              message: this.$t('clientmanage.rules.payoutQueryStatus.required'),
              trigger: 'blur'
            },
            merchantType: {
              required: true,
              message: this.$t('clientmanage.rules.merchantType.required'),
              trigger: 'change'
            },
            merchantWithdrawalType: {
              required: true,
              message: this.$t('clientmanage.rules.merchantWithdrawalType.required'),
              trigger: 'change'
            },
            agentAcct: {
              required: true,
              message: this.$t('clientmanage.rules.agentAcct.required'),
              trigger: 'change'
            },
            merchantModel: {
              required: true,
              message: this.$t('clientmanage.rules.merchantModel.required'),
              trigger: 'change'
            },
            merchantResources: {
              required: true,
              message: this.$t('clientmanage.rules.merchantResources.required'),
              trigger: 'change'
            },
            //新增商户的验证规则对象
            merchantName: [
              {
                required: true,
                message: this.$t('clientmanage.updataDia.checkName'),
                trigger: 'blur'
              },
              {
                validator: (rule, value, cb) => {
                  const username = /^[0-9a-zA-Z]{1,20}$/;
                  if (username.test(value)) {
                    return cb();
                  }
                  cb(new Error(this.$t('accountmanager.checkNameErr')));
                },
                trigger: 'blur'
              }
            ],
            // phone: [
            //   {
            //     required: true,
            //     message: this.$t('accountmanager.addFormPhone'),
            //     trigger: 'blur'
            //   },
            //   {
            //     validator: (rule, value, cb) => {
            //       if (validPhone(value)) {
            //         return cb();
            //       }
            //       cb(new Error(this.$t('accountmanager.checkPhoneErr')));
            //     },
            //     trigger: 'blur'
            //   }
            // ],
            // email: [
            //   {
            //     required: true,
            //     message: this.$t('accountmanager.addFormEmail'),
            //     trigger: 'blur'
            //   },
            //   {
            //     validator: (rule, value, cb) => {
            //       if (validEmail(value)) {
            //         return cb();
            //       }
            //       cb(new Error(this.$t('accountmanager.checkEmailErr')));
            //     },
            //     trigger: 'blur'
            //   }
            // ],
            payPass: [
              {
                required: true,
                message: this.$t('clientmanage.rules.payPass.required'),
                trigger: 'blur'
              },
              {
                validator: (rule, value, cb) => {
                  if (!betweenLenNumber(6, 20, value)) {
                    cb(new Error(this.$t('clientmanage.rules.payPass.max')));
                  } else {
                    return cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            userPass: [
              {
                required: true,
                message: this.$t('accountmanager.addFormPass'),
                trigger: 'blur'
              },
              {
                validator: (rule, value, cb) => {
                  if (checkPass(value)) {
                    return cb();
                  }
                  cb(new Error(this.$t('accountmanager.checkPassErr')));
                },
                trigger: 'blur'
              }
            ],
            merchantWithdrawalFee: [
              {
                required: true,
                message: this.$t(`clientmanage.rules.merchantWithdrawalFee.required`),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!isNumber(value)) {
                    cb(new Error(this.$t(`clientmanage.rules.merchantWithdrawalFee.type`)));
                  } else if (value < 0) {
                    cb(new Error(this.$t(`clientmanage.rules.merchantWithdrawalFee.min`)));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            payoutFixedFee: [
              {
                required: true,
                message: this.$t('clientmanage.rules.payoutFixedFee.required'),
                trigger: 'blur'
              },
            ],

            ...[
              'card',
              'momo',
              'momoIpay',
              'onlineBankingDirectConnect',
              'onlineBankingQr',
              'payOnBehalfOf',
              'viettelpay',
              'zalo',
              'usdt',
              'momoBank',
              'zaloBank',
              'vtpayBank',
            ].reduce((acc, curr) => {
              acc[curr] = [
                {
                  required: true,
                  message: this.$t(`clientmanage.rules.${curr}.required`),
                  trigger: 'blur'
                },
                {
                  validator: (rules, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t(`clientmanage.rules.${curr}.type`)));
                    } else if (value < 0) {
                      cb(new Error(this.$t(`clientmanage.rules.${curr}.min`)));
                    } else if (value > 100) {
                      cb(new Error(this.$t(`clientmanage.rules.${curr}.max`)));
                    } else if (
                      Number(value).toString().split('.')[1] &&
                      Number(value).toString().split('.')[1].length > 2
                    ) {
                      cb(new Error(this.$t(`clientmanage.rules.${curr}.float`)));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ];
              return acc;
            }, {})
          }
        }
      };
    },
    formatParams() {
      const _form = Object.keys(this.addClient).reduce((acc, key) => {
        if (!this.isAdd && ['payPass', 'userPass'].indexOf(key) > -1) {
          /**
           * 如果格式化参数为update ，则干掉passwd相关字段
           */
          return acc;
        }
        if (this.addClient[key] === 0 || this.addClient[key]) {
          acc[key] = this.addClient[key];
        }
        return acc;
      }, {});
      return {
        ..._form,
        roleId: this.roleId,
        merchantChannelIds: this.checkedChannels.length > 0 ? this.checkedChannels.join(',') : ''
      };
    },
    async wallettype() {
      const { data } = await merchantApi.getType();
      if (data) {
        if (data.code === 200) {
          this.wallettypes = data.data;
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async getClient() {
      this.loading = true;
      const { data } = await merchantApi.getPage({
        data: this.searchQuery,
        params: this.pagination
      });
      if (data && data.code === 200) {
        this.tableData = data.data;
        this.loading = false;
      } else {
        this.$message.error(this.$t('status.error'));
        this.loading = false;;
      }
    },
    async getAgents() {
      const { data } = await ordersApi.getMerchantData({
        data: {
          merchantType: 1
        }
      });
      if (data && data.code === 200) {
        this.agents = data.data;
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    async roleList() {
      let { data } = await merchantApi.getRole({ no: 1, size: 100, query: {} });
      if (data) {
        if (data.code === 200) {
          this.rolestorage = data.data.list;
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    handleOpen(row) {
      if (!row) {
        this.addClientDialogVisible = true;
        this.isAdd = true;
        this.handleEmpty();
        return;
      }
      let saveRow = JSON.parse(JSON.stringify(row));
      if (saveRow) {
        this.isAdd = false;
        this.checkboxes = {};
        this.checkedChannels = [];
        this.addClient = Object.keys(this.addClient).reduce((acc, curr) => {
          acc[curr] = saveRow[curr];
          return acc;
        }, {});
        this.$nextTick(async () => {
          let { data } = await merchantApi.getChannelList({ merchantNo: row.merchantNo });
          if (data && data.code == 200) {
            this.checkboxes = data.data || {};
          }
          this.addClientDialogVisible = true;
        });
      }
    },

    handleEmpty() {
      this.addClient = {
        //新增商户的参数对象
        id: '',
        merchantWallet: 'all',
        merchantStatus: 0,
        type: '',

        merchantModel: null,
        merchantResources: 0,
        merchantType: null,
        agentAcct: '',
        merchantName: '',
        userPass: '',
        payPass: '',
        phone: '',
        email: '',
        withdrawMinSafetyAmount:0,//商户取款最低安全限额
        withdrawWarningGroupId:'',//取款警告群组id
        payoutWarningGroupId: '', //代付警告群组id
        payoutMinSafetyAmount: 0, //商户代付最低安全限额
        // 手续费
        card: '',
        merchantWithdrawalFee: '',
        merchantWithdrawalType: 1,
        momo: '',
        momoIpay: '',
        onlineBankingDirectConnect: '',
        onlineBankingQr: '',
        payOnBehalfOf: '',
        viettelpay: '',
        zalo: '',
        usdt: '',
        qrPro: '',
        orderPrefix: '',
        payoutQueryUrl:'',
        payoutQueryStatus:null,
        payoutFixedFee:'',
        momoBank: '',
        vtpayBank: '',
        zaloBank:'',
      };
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.isAdd) {
            const { data } = await merchantApi.doAdd(this.formatParams());
            this.doSuccess(data);
            this.$refs.qrCodeModal.showModal(data.data);
          } else {
            /**参数格式化函数会根据isAdd 过滤掉pass字段 */
            const { data } = await merchantApi.doUpdate(this.formatParams());
            this.doSuccess(data);
          }
        }
      });
    },
    async merchantStatusChange(row, field) {
      let params = { merchantNo: row.merchantNo, id: row.id };
      params[field] = row[field];
      const { data } = await merchantApi.updateStatus(params);
      if (data.code === 200) {
        this.$message.success(this.$t('btns.success'));
      } else {
        row[field] = row[field] == 0 ? 1 : 0;
      }
    },
    doSuccess(data) {
      if (data) {
        if (data.code === 200) {
          this.getClient();
          this.addClientDialogVisible = false;
          this.handleEmpty();
        } else {
          this.$message.error(data.msg);
        }
      } else {
        this.$message.error(data.msg);
      }
    },
    async handleExport() {
      const { data } = await merchantApi.doExport({
        merchantName: this.searchQuery.merchantName
      });
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-List${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    async checkClient(merchantNo) {
      const { data } = await this.$http.get(`/merchant/getMerchant/${merchantNo}`);
      if (data && data.code === 200) {
        this.$store.commit('SET_CLIENTDATA', data.data);
        // // 跳转详情页
        // this.$router.push({ name: "merchantdetails" });
        this.isDetail = true;
        this.newKey = Date.parse(new Date());
      } else {
        return this.$message.error(data.msg);
      }
    },
    async showKeysInfo(row) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      const { data } = await merchantApi.getSecretKeys({
        merchantNo: row.merchantNo,
        googleCode: Code.value
      });
      console.log(data);
      if (data && data.code == 200) {
        this.merchantKeys = Object.assign({}, data.data);
        this.merchantKeys.secretQr = `data:image/png;base64,${data.data.secretQr}`;
        this.showKeysInfoFlag = true;
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    async resetpassword(row) {
      // 弹框询问用户是否重置密码
      const confirmResult = await this.$confirm(
        this.$t('accountmanager.hintmessage'),
        this.$t('btns.hint'),
        {
          confirmButtonText: this.$t('btns.confirm'),
          cancelButtonText: this.$t('btns.cancel'),
          type: 'warning'
        }
      ).catch((err) => err);
      // 用户确认删除 返回值为字符串 confirm
      // 用户取消删除 返回值为字符串 cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info(this.$t('btns.cancel'));
      }
      this.loading = true;
      const res = await this.$http.get('/merchant/restPayPassword?merchantId=' + row.merchantNo);
      this.loading = false;
      if (res.data.code != 200) {
        return this.$message.error(this.$t('btns.error'));
      }
      this.$message.success(this.$t('btns.success'));
      // 刷新数据列表
      this.getClient();
    },
    // 取消修改
    clearChange() {
      this.$message.warning('cancel');
      this.getClient();
    },
    //刷新缓存
    async refreshCache() {
      const confirmResult = await this.$confirm(
        this.$t('accountmanager.refreshCacheHint'),
        this.$t('btns.hint'),
        {
          confirmButtonText: this.$t('btns.confirm'),
          cancelButtonText: this.$t('btns.cancel'),
          type: 'warning'
        }
      ).catch((err) => err);

      if (confirmResult !== 'confirm') {
        return this.$message.info(this.$t('btns.cancel'));
      }

      const res = await merchantApi.refreshCache();

      if (res.data.code != 200) {
        return this.$message.error(this.$t('btns.error'));
      }
      this.$message.success(this.$t('btns.success'));
      // 刷新数据列表
      this.getClient();
    },
  }
};
</script>

<style scoped>
.box-card,
.table,
.pag {
  margin-top: 20px;
}

.el-col .el-button:nth-child(1),
.el-col .el-button:nth-child(2) {
  padding: 10px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/clientmanage/index.vue